import React from 'react';

import { TabHeader } from 'Modules/ui2/components';

import styles from './index.module.scss';


const steps = [
    'Регистрация',
    'Активация',
    'Полномочия',
    'Документы',
];

export const RegistrationStep = ({ step }) => (
    <TabHeader className={styles.tabs} tabs={steps} value={step} />
);
